import { Client } from "../../clients/client";

import { PaginationForm, Pagination } from "@/common/mixins/pagination";
import { Shop } from "./models/Shop";

export class ShopUseCase {
  constructor(private client: Client) {}

  public async getShops(form: PaginationForm): Promise<Pagination<Shop>> {
    return this.client.shops.getShops({
      page: form && form.page,
      limit: form && form.perPage
    });
  }
  public async createToken(shop: Shop) {
    return this.client.shops.createShopRegisterToken({
      shopId: shop.id
    });
  }
}
